/**
 * Blog Filter AJAX Handler
 * Handles search, category filter, and load more for blog listing
 */

/**
 * Initialize the styled category dropdown while keeping the native select
 * as the source of truth for blog filtering.
 */
function setupCustomCategorySelect() {
    var dropdowns = document.querySelectorAll('.filters-section .custom-taxonomy-select');

    function closeDropdown(dropdown, returnFocus) {
        var trigger = dropdown.querySelector('.custom-select-trigger');
        var menu = dropdown.querySelector('.custom-select-menu');
        var chevron = dropdown.querySelector('.custom-select-chevron');

        if (menu) menu.classList.add('hidden');
        if (chevron) chevron.classList.remove('rotate-180');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');

        if (returnFocus && trigger) trigger.focus();
    }

    function closeOtherDropdowns(currentDropdown) {
        dropdowns.forEach(function(dropdown) {
            if (dropdown !== currentDropdown) closeDropdown(dropdown);
        });
    }

    dropdowns.forEach(function(dropdown) {
        var select = dropdown.querySelector('#blog-category-select, .taxonomy-select');
        var trigger = dropdown.querySelector('.custom-select-trigger');
        var label = dropdown.querySelector('.custom-select-label');
        var menu = dropdown.querySelector('.custom-select-menu');
        var chevron = dropdown.querySelector('.custom-select-chevron');
        var options = Array.from(dropdown.querySelectorAll('.custom-select-option'));

        if (!select || !trigger || !label || !menu || options.length === 0) return;

        function updateSelectedOption() {
            var selectedOption = options.find(function(option) {
                return option.dataset.value === select.value;
            }) || options[0];
            label.textContent = selectedOption.textContent.trim();

            options.forEach(function(option) {
                var isSelected = option === selectedOption;
                option.setAttribute('aria-selected', String(isSelected));
                option.classList.toggle('bg-[#FFF3E6]', isSelected);
                option.classList.toggle('font-medium', isSelected);
            });
        }

        function openDropdown() {
            closeOtherDropdowns(dropdown);
            menu.classList.remove('hidden');
            if (chevron) chevron.classList.add('rotate-180');
            trigger.setAttribute('aria-expanded', 'true');
        }

        trigger.addEventListener('click', function() {
            if (menu.classList.contains('hidden')) {
                openDropdown();
            } else {
                closeDropdown(dropdown);
            }
        });

        trigger.addEventListener('keydown', function(event) {
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                openDropdown();
                var selectedOption = options.find(function(option) {
                    return option.dataset.value === select.value;
                }) || options[0];
                selectedOption.focus();
            }
        });

        options.forEach(function(option) {
            option.addEventListener('click', function() {
                select.value = option.dataset.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                closeDropdown(dropdown, true);
            });
        });

        menu.addEventListener('keydown', function(event) {
            var currentIndex = options.indexOf(document.activeElement);

            if (event.key === 'Escape') {
                event.preventDefault();
                closeDropdown(dropdown, true);
            } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                var direction = event.key === 'ArrowDown' ? 1 : -1;
                var nextIndex = (currentIndex + direction + options.length) % options.length;
                options[nextIndex].focus();
            } else if (event.key === 'Home' || event.key === 'End') {
                event.preventDefault();
                options[event.key === 'Home' ? 0 : options.length - 1].focus();
            }
        });

        select.addEventListener('change', updateSelectedOption);
        updateSelectedOption();
    });

    document.addEventListener('click', function(event) {
        dropdowns.forEach(function(dropdown) {
            if (!dropdown.contains(event.target)) closeDropdown(dropdown);
        });
    });
}

export function initBlogFilter() {
    var searchInput = document.getElementById('blog-search-input');
    var categorySelect = document.getElementById('blog-category-select');
    var postsContainer = document.getElementById('blog-posts-container');
    var ajaxLoader = document.getElementById('blog-ajax-loader');
    var loadMoreBtn = document.getElementById('blog-load-more');
    var loadMoreContainer = document.getElementById('blog-load-more-container');
    var searchIcon = document.querySelector('.search-icon');
    var loadingIcon = document.querySelector('.loading-icon');
    var debounceTimer;
    var currentPage = 1;
    var isLoading = false;
    
    // Get AJAX data from localized script
    var ajaxUrl = window.vtBlogFilter ? window.vtBlogFilter.ajaxurl : '';
    var nonce = window.vtBlogFilter ? window.vtBlogFilter.nonce : '';
    
    if (!ajaxUrl || !postsContainer) return;

    setupCustomCategorySelect();
    
    function showLoadMoreLoading() {
        if (loadMoreBtn) {
            loadMoreBtn.style.pointerEvents = 'none';
            loadMoreBtn.style.opacity = '0.8';
            var spinner = loadMoreBtn.querySelector('.btn-spinner');
            var btnText = loadMoreBtn.querySelector('.btn-text');
            if (spinner) spinner.style.display = 'inline-block';
            if (btnText) btnText.textContent = 'Loading...';
        }
    }
    
    function hideLoadMoreLoading() {
        if (loadMoreBtn) {
            loadMoreBtn.style.pointerEvents = '';
            loadMoreBtn.style.opacity = '';
            var spinner = loadMoreBtn.querySelector('.btn-spinner');
            var btnText = loadMoreBtn.querySelector('.btn-text');
            if (spinner) spinner.style.display = 'none';
            if (btnText) btnText.textContent = loadMoreBtn.dataset.text || 'Load More';
        }
    }
    
    function showLoading(isNewSearch) {
        if (searchIcon) searchIcon.classList.add('hidden');
        if (loadingIcon) loadingIcon.classList.remove('hidden');
        isLoading = true;
        
        // Show placeholder cards for new searches (not load more)
        if (isNewSearch && ajaxLoader && postsContainer) {
            postsContainer.style.display = 'none';
            ajaxLoader.style.display = 'grid';
        }
        
        // Hide load more during new search, but show loading state for load more
        if (isNewSearch && loadMoreContainer) {
            loadMoreContainer.style.display = 'none';
        }
    }
    
    function hideLoading() {
        if (searchIcon) searchIcon.classList.remove('hidden');
        if (loadingIcon) loadingIcon.classList.add('hidden');
        isLoading = false;
        
        // Hide placeholder, show posts
        if (ajaxLoader && postsContainer) {
            ajaxLoader.style.display = 'none';
            postsContainer.style.display = 'grid';
        }
    }
    
    function filterPosts(append) {
        if (isLoading) return;
        
        if (append) {
            showLoadMoreLoading();
        }
        showLoading(!append);
        
        var formData = new FormData();
        formData.append('action', 'vt_filter_blog_posts');
        formData.append('nonce', nonce);
        formData.append('search', searchInput ? searchInput.value : '');
        formData.append('category', categorySelect ? categorySelect.value : '');
        formData.append('paged', append ? currentPage : 1);
        
        fetch(ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
            hideLoading();
            hideLoadMoreLoading();
            
            if (data.success) {
                if (append) {
                    // Create a temporary container to parse the HTML
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.data.html;
                    
                    // Add animation to each new card and append with stagger
                    var newCards = tempDiv.children;
                    var delay = 0;
                    while (newCards.length > 0) {
                        var card = newCards[0];
                        // Apply fade-in animation using inline styles
                        card.style.opacity = '0';
                        card.style.transform = 'translateY(20px)';
                        card.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out';
                        card.style.transitionDelay = delay + 'ms';
                        postsContainer.appendChild(card);
                        
                        // Trigger animation after append
                        (function(c) {
                            requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    c.style.opacity = '1';
                                    c.style.transform = 'translateY(0)';
                                });
                            });
                        })(card);
                        
                        delay += 100; // Stagger each card by 100ms
                    }
                } else {
                    postsContainer.innerHTML = data.data.html;
                    currentPage = 1;
                }
                
                // Update load more button
                if (loadMoreBtn && loadMoreContainer) {
                    if (currentPage >= data.data.max_pages || data.data.max_pages <= 1) {
                        loadMoreContainer.style.display = 'none';
                    } else {
                        loadMoreContainer.style.display = 'flex';
                        loadMoreBtn.dataset.max = data.data.max_pages;
                    }
                }
            }
        })
        .catch(function(error) {
            hideLoading();
            hideLoadMoreLoading();
            console.error('Filter error:', error);
        });
    }
    
    // Search input - debounced
    if (searchInput) {
        searchInput.addEventListener('input', function() {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function() {
                filterPosts(false);
            }, 500);
        });
        
        searchInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(debounceTimer);
                filterPosts(false);
            }
        });
    }
    
    // Category change
    if (categorySelect) {
        categorySelect.addEventListener('change', function() {
            filterPosts(false);
        });
    }
    
    // Load more button
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function() {
            currentPage++;
            filterPosts(true);
        });
    }
}

/**
 * Category Page Filter AJAX Handler
 * Handles search and load more for category archive
 */
export function initCategoryFilter() {
    var searchInput = document.getElementById('category-search-input');
    var postsContainer = document.getElementById('category-posts-container');
    var ajaxLoader = document.getElementById('category-ajax-loader');
    var loadMoreBtn = document.getElementById('category-load-more');
    var loadMoreContainer = document.getElementById('category-load-more-container');
    var searchIcon = searchInput ? searchInput.parentElement.querySelector('.search-icon') : null;
    var loadingIcon = searchInput ? searchInput.parentElement.querySelector('.loading-icon') : null;
    var debounceTimer;
    var currentPage = 1;
    var isLoading = false;
    
    // Get AJAX data from localized script (reuse vtBlogFilter)
    var ajaxUrl = window.vtBlogFilter ? window.vtBlogFilter.ajaxurl : '';
    var nonce = window.vtBlogFilter ? window.vtBlogFilter.nonce : '';
    var category = searchInput ? searchInput.dataset.category : (loadMoreBtn ? loadMoreBtn.dataset.category : '');
    
    if (!ajaxUrl || !postsContainer || !category) return;
    
    function showLoadMoreLoading() {
        if (loadMoreBtn) {
            loadMoreBtn.style.pointerEvents = 'none';
            loadMoreBtn.style.opacity = '0.8';
            var spinner = loadMoreBtn.querySelector('.btn-spinner');
            var btnText = loadMoreBtn.querySelector('.btn-text');
            if (spinner) spinner.style.display = 'inline-block';
            if (btnText) btnText.textContent = 'Loading...';
        }
    }
    
    function hideLoadMoreLoading() {
        if (loadMoreBtn) {
            loadMoreBtn.style.pointerEvents = '';
            loadMoreBtn.style.opacity = '';
            var spinner = loadMoreBtn.querySelector('.btn-spinner');
            var btnText = loadMoreBtn.querySelector('.btn-text');
            if (spinner) spinner.style.display = 'none';
            if (btnText) btnText.textContent = loadMoreBtn.dataset.text || 'Load More';
        }
    }
    
    function showLoading(isNewSearch) {
        if (searchIcon) searchIcon.classList.add('hidden');
        if (loadingIcon) loadingIcon.classList.remove('hidden');
        isLoading = true;
        
        if (isNewSearch && ajaxLoader && postsContainer) {
            postsContainer.style.display = 'none';
            ajaxLoader.style.display = 'grid';
        }
        
        if (isNewSearch && loadMoreContainer) {
            loadMoreContainer.style.display = 'none';
        }
    }
    
    function hideLoading() {
        if (searchIcon) searchIcon.classList.remove('hidden');
        if (loadingIcon) loadingIcon.classList.add('hidden');
        isLoading = false;
        
        if (ajaxLoader && postsContainer) {
            ajaxLoader.style.display = 'none';
            postsContainer.style.display = 'grid';
        }
    }
    
    function filterPosts(append) {
        if (isLoading) return;
        
        if (append) {
            showLoadMoreLoading();
        }
        showLoading(!append);
        
        var formData = new FormData();
        formData.append('action', 'vt_filter_blog_posts');
        formData.append('nonce', nonce);
        formData.append('search', searchInput ? searchInput.value : '');
        formData.append('category', category);
        formData.append('paged', append ? currentPage : 1);
        
        fetch(ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
            hideLoading();
            hideLoadMoreLoading();
            
            if (data.success) {
                if (append) {
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.data.html;
                    
                    var newCards = tempDiv.children;
                    var delay = 0;
                    while (newCards.length > 0) {
                        var card = newCards[0];
                        card.style.opacity = '0';
                        card.style.transform = 'translateY(20px)';
                        card.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out';
                        card.style.transitionDelay = delay + 'ms';
                        postsContainer.appendChild(card);
                        
                        (function(c) {
                            requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    c.style.opacity = '1';
                                    c.style.transform = 'translateY(0)';
                                });
                            });
                        })(card);
                        
                        delay += 100;
                    }
                } else {
                    postsContainer.innerHTML = data.data.html;
                    currentPage = 1;
                }
                
                if (loadMoreBtn && loadMoreContainer) {
                    if (currentPage >= data.data.max_pages || data.data.max_pages <= 1) {
                        loadMoreContainer.style.display = 'none';
                    } else {
                        loadMoreContainer.style.display = 'flex';
                        loadMoreBtn.dataset.max = data.data.max_pages;
                    }
                }
            }
        })
        .catch(function(error) {
            hideLoading();
            hideLoadMoreLoading();
            console.error('Category filter error:', error);
        });
    }
    
    // Search input - debounced
    if (searchInput) {
        searchInput.addEventListener('input', function() {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function() {
                filterPosts(false);
            }, 500);
        });
        
        searchInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(debounceTimer);
                filterPosts(false);
            }
        });
    }
    
    // Load more button
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function() {
            currentPage++;
            filterPosts(true);
        });
    }
}

/**
 * Author Page Filter AJAX Handler
 * Handles search and load more for author archive
 */
export function initAuthorFilter() {
    var searchInput = document.getElementById('author-search-input');
    var postsContainer = document.getElementById('author-posts-container');
    var ajaxLoader = document.getElementById('author-ajax-loader');
    var loadMoreBtn = document.getElementById('author-load-more');
    var loadMoreContainer = document.getElementById('author-load-more-container');
    var searchIcon = searchInput ? searchInput.parentElement.querySelector('.search-icon') : null;
    var loadingIcon = searchInput ? searchInput.parentElement.querySelector('.loading-icon') : null;
    var debounceTimer;
    var currentPage = 1;
    var isLoading = false;
    
    // Get AJAX data from localized script (reuse vtBlogFilter)
    var ajaxUrl = window.vtBlogFilter ? window.vtBlogFilter.ajaxurl : '';
    var nonce = window.vtBlogFilter ? window.vtBlogFilter.nonce : '';
    var authorId = searchInput ? searchInput.dataset.authorId : (loadMoreBtn ? loadMoreBtn.dataset.authorId : '');
    
    if (!ajaxUrl || !postsContainer || !authorId) return;
    
    function showLoadMoreLoading() {
        if (loadMoreBtn) {
            loadMoreBtn.style.pointerEvents = 'none';
            loadMoreBtn.style.opacity = '0.8';
            var spinner = loadMoreBtn.querySelector('.btn-spinner');
            var btnText = loadMoreBtn.querySelector('.btn-text');
            if (spinner) spinner.style.display = 'inline-block';
            if (btnText) btnText.textContent = 'Loading...';
        }
    }
    
    function hideLoadMoreLoading() {
        if (loadMoreBtn) {
            loadMoreBtn.style.pointerEvents = '';
            loadMoreBtn.style.opacity = '';
            var spinner = loadMoreBtn.querySelector('.btn-spinner');
            var btnText = loadMoreBtn.querySelector('.btn-text');
            if (spinner) spinner.style.display = 'none';
            if (btnText) btnText.textContent = loadMoreBtn.dataset.text || 'Load More';
        }
    }
    
    function showLoading(isNewSearch) {
        if (searchIcon) searchIcon.classList.add('hidden');
        if (loadingIcon) loadingIcon.classList.remove('hidden');
        isLoading = true;
        
        if (isNewSearch && ajaxLoader && postsContainer) {
            postsContainer.style.display = 'none';
            ajaxLoader.style.display = 'grid';
        }
        
        if (isNewSearch && loadMoreContainer) {
            loadMoreContainer.style.display = 'none';
        }
    }
    
    function hideLoading() {
        if (searchIcon) searchIcon.classList.remove('hidden');
        if (loadingIcon) loadingIcon.classList.add('hidden');
        isLoading = false;
        
        if (ajaxLoader && postsContainer) {
            ajaxLoader.style.display = 'none';
            postsContainer.style.display = 'grid';
        }
    }
    
    function filterPosts(append) {
        if (isLoading) return;
        
        if (append) {
            showLoadMoreLoading();
        }
        showLoading(!append);
        
        var formData = new FormData();
        formData.append('action', 'vt_filter_blog_posts');
        formData.append('nonce', nonce);
        formData.append('search', searchInput ? searchInput.value : '');
        formData.append('author_id', authorId);
        formData.append('paged', append ? currentPage : 1);
        
        fetch(ajaxUrl, {
            method: 'POST',
            body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
            hideLoading();
            hideLoadMoreLoading();
            
            if (data.success) {
                if (append) {
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data.data.html;
                    
                    var newCards = tempDiv.children;
                    var delay = 0;
                    while (newCards.length > 0) {
                        var card = newCards[0];
                        card.style.opacity = '0';
                        card.style.transform = 'translateY(20px)';
                        card.style.transition = 'opacity 0.4s ease-out, transform 0.4s ease-out';
                        card.style.transitionDelay = delay + 'ms';
                        postsContainer.appendChild(card);
                        
                        (function(c) {
                            requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    c.style.opacity = '1';
                                    c.style.transform = 'translateY(0)';
                                });
                            });
                        })(card);
                        
                        delay += 100;
                    }
                } else {
                    postsContainer.innerHTML = data.data.html;
                    currentPage = 1;
                }
                
                if (loadMoreBtn && loadMoreContainer) {
                    if (currentPage >= data.data.max_pages || data.data.max_pages <= 1) {
                        loadMoreContainer.style.display = 'none';
                    } else {
                        loadMoreContainer.style.display = 'flex';
                        loadMoreBtn.dataset.max = data.data.max_pages;
                    }
                }
            }
        })
        .catch(function(error) {
            hideLoading();
            hideLoadMoreLoading();
            console.error('Author filter error:', error);
        });
    }
    
    // Search input - debounced
    if (searchInput) {
        searchInput.addEventListener('input', function() {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function() {
                filterPosts(false);
            }, 500);
        });
        
        searchInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                clearTimeout(debounceTimer);
                filterPosts(false);
            }
        });
    }
    
    // Load more button
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function() {
            currentPage++;
            filterPosts(true);
        });
    }
}

